import React, { useEffect, useRef, useState } from 'react'
import { fmt } from '../api.js'
import { portal } from '../portalApi.js'

// 위하고식 거래처 코드도움: F2 또는 검색 버튼 → 전체/일반/금융/카드 탭 + 검색 팝업
const VENDOR_KIND_TABS = [
  { key: 'general', label: '일반' },
  { key: 'bank', label: '금융' },
  { key: 'card', label: '카드' },
]

export function VendorPickerModal({ initialQuery, onSelect, onClose }) {
  const [kind, setKind] = useState('general')
  const [q, setQ] = useState(initialQuery || '')
  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [counts, setCounts] = useState({})
  const [hi, setHi] = useState(0)
  const inputRef = useRef(null)

  useEffect(() => { inputRef.current?.focus() }, [])

  useEffect(() => {
    const t = setTimeout(() => {
      portal.get(`/api/vendors?kind=${kind}&q=${encodeURIComponent(q.trim())}&limit=100`)
        .then((r) => { setRows(r.vendors ?? []); setTotal(r.total ?? 0); setCounts(r.counts ?? {}); setHi(0) })
        .catch(() => { setRows([]); setTotal(0) })
    }, 200)
    return () => clearTimeout(t)
  }, [kind, q])

  const pick = (v) => v && onSelect({ ...v, kind })

  const onKeyDown = (e) => {
    if (e.key === 'Escape') { onClose(); return }
    if (e.key === 'ArrowDown') { e.preventDefault(); setHi((h) => Math.min(h + 1, rows.length - 1)); return }
    if (e.key === 'ArrowUp') { e.preventDefault(); setHi((h) => Math.max(h - 1, 0)); return }
    if (e.key === 'Enter') { e.preventDefault(); pick(rows[hi]); return }
  }

  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <div className="modal-panel vendor-picker" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>거래처 코드도움</h3>
          <button type="button" className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-tabs">
          {VENDOR_KIND_TABS.map((t) => (
            <button key={t.key} type="button"
              className={'modal-tab' + (kind === t.key ? ' active' : '')}
              onClick={() => setKind(t.key)}>
              {t.label}{counts[t.key] !== undefined ? ` (${fmt(counts[t.key])})` : ''}
            </button>
          ))}
        </div>
        <div className="modal-table-wrap">
          <table className="modal-table">
            <thead>
              <tr><th>Code</th><th>거래처명</th><th>사업자(계좌)번호</th><th>대표자/담당자</th></tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={4} className="c muted">검색 결과가 없습니다</td></tr>}
              {rows.map((v, i) => (
                <tr key={v.code} className={i === hi ? 'hi' : ''}
                  onMouseEnter={() => setHi(i)} onClick={() => pick(v)}>
                  <td>{v.code}</td><td>{v.name}</td>
                  <td>{v.bizNo || v.accountNo || ''}</td><td>{v.repName || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal-footer">
          <input ref={inputRef} placeholder="찾을 내용 (거래처명·코드·사업자번호·계좌번호)" value={q}
            onChange={(e) => setQ(e.target.value)} onKeyDown={onKeyDown} />
          <span className="muted" style={{ fontSize: 12 }}>{fmt(total)}건</span>
          <button type="button" className="btn secondary" onClick={onClose}>취소(esc)</button>
          <button type="button" className="btn" disabled={!rows.length} onClick={() => pick(rows[hi])}>확인(enter)</button>
        </div>
      </div>
    </div>
  )
}

export default VendorPickerModal
